<template>
  <tr :active="props.selected" @click.stop="clickRow(props)">

    <td>
      <v-checkbox v-model=" props.selected" primary hide-details @click.stop="cellCheckRow(props)">
      </v-checkbox>
    </td>
    <td v-for="(header, index) in headers" :key="header.value" >
      <slot :name="'table-cell-'+header.value" :props="{props}">
        <v-layout v-show="!IsSelected" align-center row v-if="header.value==='O-Actions'">
          <v-tooltip bottom v-for="action in actions" :key="action.value" style="margin: 0px;">
            <template slot="activator">
              <v-btn icon flat @click="bus.$emit(action.event,props.item)"
                style="margin: 0px;width: 24px;height: 24px;">
                <v-icon style="margin: 0px;" small>{{action.icon}}</v-icon>
              </v-btn>
            </template>
            <span>{{action.text}}</span>
          </v-tooltip>

        </v-layout>
        <v-tooltip bottom v-else-if="header.value==='O-View'">
          <template slot="activator">
            <v-btn icon flat @click="bus.$emit('viewItem',props.item)">
              <v-icon color="primary">list</v-icon>
            </v-btn>
            <!-- <v-btn color="success">查看明细</v-btn> -->
          </template>
          <span>{{header.text}}</span>
        </v-tooltip>
        <vuetify-cell :prop="header" :index="props.index" :model="props.item" :multiple="IsSelected" v-else>

        </vuetify-cell>



      </slot>
    </td>
  </tr>
</template>

<style scoped>

</style>

<script>
  import VuetifyRow from "./vuetifyRow.ts";
  export default VuetifyRow;
</script>